interface AuthConfig {
    clientID: string;
    domain: string;
    callbackURL: string;
}

export const AUTH_CONFIG: AuthConfig = {
    clientID: 'Zq-zzNu3_m0zYxrDeoYR8n6FDZ89hyVR',
    domain: 'multimode.auth0.com',
    callbackURL: 'http://localhost:4200/home'
};


// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/+auth/auth0-variables.ts